module.exports = __webpack_public_path__ + "img/bps_logo_store.a344d8dc.svg";